import React from 'react';

const DiameterSelector = ({ type, value, onChange, options }) => {
  return (
    <div className="mt-4">
      <label className="block text-sm font-medium mb-3">
        {type === 'jonc' ? 'Diamètre du jonc (mm)' : 'Diamètre du fourreau (mm)'}
      </label>
      <div className={`grid gap-2 ${type === 'jonc' ? 'grid-cols-7' : 'grid-cols-8'}`}>
        {options.map((diametre) => (
          <button
            key={diametre}
            onClick={() => onChange(diametre)}
            className={`p-2 border-2 rounded-lg text-center transition-all ${
              value === diametre
                ? 'border-celadon bg-celadon text-white'
                : 'border-gray-200 hover:border-gray-300'
            }`}
          >
            <p className="text-sm font-medium">{diametre}</p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default DiameterSelector;